import DocumentSlots from './DocumentSlots';
import DocumentSlotUploadModal from './DocumentSlotUploadModal';

export default {
  DocumentSlots,
  DocumentSlotUploadModal,
};
